"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useExportHandler = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = require("react");
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var downloadFile_1 = require("../../../_staging/fileUtils/downloadFile");
var locales_1 = require("../../../locales");
exports.useExportHandler = function () {
    var _a = sdk_ui_kit_1.useToastMessage(), addProgress = _a.addProgress, addSuccess = _a.addSuccess, addError = _a.addError, removeMessage = _a.removeMessage;
    var lastExportMessageId = react_1.useRef("");
    return react_1.useCallback(function (exportFunction, exportConfig) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var exportResultUri, err_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    lastExportMessageId.current = addProgress(locales_1.messages.messagesExportResultStart, 
                    // make sure the message stays there until removed by either success or error
                    { duration: 0 });
                    return [4 /*yield*/, exportFunction(exportConfig)];
                case 1:
                    exportResultUri = _a.sent();
                    if (lastExportMessageId.current) {
                        removeMessage(lastExportMessageId.current);
                    }
                    addSuccess(locales_1.messages.messagesExportResultSuccess);
                    downloadFile_1.downloadFile(exportResultUri);
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    if (lastExportMessageId.current) {
                        removeMessage(lastExportMessageId.current);
                    }
                    if (sdk_backend_spi_1.isProtectedDataError(err_1)) {
                        addError(locales_1.messages.messagesExportResultRestrictedError);
                    }
                    else {
                        addError(locales_1.messages.messagesExportResultError);
                    }
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, []);
};
//# sourceMappingURL=useExportHandler.js.map